import NBadge from './NBadge.vue';

export default NBadge;